module.exports = __webpack_public_path__ + "img/news_all_hover.784fc689.svg";